import { render, staticRenderFns } from "./DocumentBenefit.vue?vue&type=template&id=0f6500cb&scoped=true"
import script from "./DocumentBenefit.vue?vue&type=script&lang=js"
export * from "./DocumentBenefit.vue?vue&type=script&lang=js"
import style0 from "./DocumentBenefit.vue?vue&type=style&index=0&id=0f6500cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6500cb",
  null
  
)

export default component.exports